import { html } from 'lit';
import { api } from '@converse/headless';
import { __ } from 'i18n';
import { getSelectedMsgIds, getSelectedMessages, stopSelecting } from '../selection.js';

/**
 * Telegram-style bar that replaces the message composer while selecting messages.
 * Shared between 1-on-1 chats (plugins/chatview) and groupchats (plugins/muc-views).
 * @param {import('@converse/headless').ChatBox|import('@converse/headless').ChatRoom} chatbox
 */
export default (chatbox) => {
    const count = getSelectedMsgIds(chatbox).length;

    const onForward = () => {
        const messages = getSelectedMessages(chatbox);
        if (!messages.length) return;
        api.modal.show('converse-forward-modal', { chatbox, messages });
    };

    return html`<div class="chat-bottom-panel chat-selection-bar-wrapper"><div class="chat-selection-bar"><button type="button" class="chat-selection-bar__cancel" title="${__('Скасувати')}" @click="${() => stopSelecting(chatbox)}"><converse-icon size="1.15em" class="fa fa-times" color="#9ab9ff"></converse-icon></button> <span class="chat-selection-bar__count">${__('Обрано: %1$s', count)}</span> <button type="button" class="chat-selection-bar__forward" title="${__('Переслати')}" ?disabled="${count === 0}" @click="${onForward}"><converse-icon size="1.2em" class="fas fa-paper-plane" color="#fff"></converse-icon></button></div></div>`;
};
